import type { Bundle, Observation } from "fhir/r4";
import type { FC } from "react";
import ObservationBundleBloc from "src/state/ObservationBundleBloc/ObservationBundleBloc";
import { useBlocNext } from "@blac/react";
import AsyncContent from "src/ui/components/AsyncContent/AsyncContent";
import Collection from "src/ui/components/StyledComponents/Collection";
import CollectionItemLink from "src/ui/components/StyledComponents/CollectionItemLink";
import CollectionTitle from "src/ui/components/StyledComponents/CollectionTitle";
import LabImportBanner from "src/ui/components/LabImportBanner/LabImportBanner";
import Translate from "src/ui/components/Translate/Translate";
import EmptyResultsState from "./StyledComponents/EmptyResultsState";

const LabResultGroupTable: FC<{
  observationBundles?: Bundle<Observation>[];
}> = (props) => {
  const [, { getVisibleBundleData }] = useBlocNext(ObservationBundleBloc);

  const observationBundlesPassed =
    typeof props.observationBundles !== "undefined";
  const { observationBundles = [] } = props;

  const noValues = observationBundlesPassed && !observationBundles.length;
  const visibleBundleData = getVisibleBundleData(observationBundles);

  return (
    <>
      <CollectionTitle style={{ marginBottom: "0.6rem" }}>
        <Translate msg="labResults" />
      </CollectionTitle>

      <LabImportBanner />

      {noValues && (
        <EmptyResultsState>
          <p className="m0 strong color-c-80">
            <Translate msg="noResultsYet" variables={{ context: "labs" }} />
          </p>
        </EmptyResultsState>
      )}

      {!noValues && (
        <AsyncContent check={[observationBundlesPassed]} height="20rem">
          <Collection className="mt-1-5">
            {visibleBundleData.map(({ link, label, subtitle, Icon }) => (
              <CollectionItemLink
                key={link}
                to={link}
                icon={<Icon />}
                label={<p className="m0">{label}</p>}
                status={<small>{subtitle}</small>}
              />
            ))}
          </Collection>
        </AsyncContent>
      )}
    </>
  );
};

export default LabResultGroupTable;
